import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ShowHideTable } from "../../components/ShowHideTable";
import SubHeaderBox from "../../components/SubHeaderBox";
import InventoryServiceTable from "./Table";
import SystemBoundary from "../../components/HeaderBox/SystemBoundary";
import inventoryServiceIcon from "../../../../../assets/design-revamp-company/category-icons/inventory_service_icon.svg";
import { getSystemBoundarySubcategory } from "../../../../../apis/Business/InventoryApi";
const InventoryPurchasedService = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState();
  const [systemBoundaryServices, setSystemBoundaryServices] = useState();
  useEffect(() => {
    getSystemBoundarySubcategory({
      businessId: businessId,
      setSystemBoundarySubCategory: setSystemBoundaryServices,
      subcategory: "purchased_services",
    });
  }, [businessId]);
  return (
    <div className="component-energy-contents">
      <div style={{ marginTop: "12px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <SubHeaderBox
            subTitle={t("PURCHASED_SERVICES")}
            subDescription={t("DESC_INV_SERVICE")}
            isNormal={true}
            number={"5.1.4"}
            icon={inventoryServiceIcon}
            showSystemBoundary={true}
            systemBoundaryProps={{
              businessId: businessId,
              systemBoundary: systemBoundaryServices,
              setSystemBoundary: setSystemBoundaryServices,
              totalObjCategory: "purchased_services",
              customStyles: { marginTop: "10px" },
              isInventory: true,
            }}
          />
        </div>
        {showTable && <InventoryServiceTable businessId={businessId} />}
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      </div>
    </div>
  );
};

export default InventoryPurchasedService;
